module.exports = __webpack_public_path__ + "img/doener-2.86f3426a.jpg";